<template>
	<DaModalFrame v-model:open="modalIsOpen">
		<ConfirmSendFeeNotice
			:in-progress="inProgress"
			:notification="{
				...notificationConfirm,
			}"
			@close="cancel"
			@submit="sendNotification"
		/>
	</DaModalFrame>
	<div class="pb-30 px-10 md-down:px-4">
		<div
			class="
				__report-lesson__header
				pt-10
				pb-10
				flex flex-nowrap
				justify-between
				items-center
			"
		>
			<div
				class="
					__record__title
					text-neutral-500
					font-semibold
					whitespace-nowrap
					flex flex-nowrap
					items-center
					text-4xl
					cursor-pointer
				"
				@click="$router.push('/fee-notices')"
			>
				<svg
					class="mr-2"
					fill="none"
					height="28"
					viewBox="0 0 28 28"
					width="28"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M17.5 7L10.5 14L17.5 21"
						stroke="#94A3B8"
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="2"
					/>
				</svg>
				Xem trước
			</div>
		</div>
		<div class="bg-white rounded-xl border p-6">
			<div class="flex items-center gap-4">
				<img
					:src="currentOrg.profile_photo.w200"
					alt="Tuition template"
					class="h-16 rounded-lg"
				/>
				<div>
					<div class="font-semibold">{{ currentOrg.name }}</div>
					<div class="text-sm text-neutral-500">
						{{ currentOrg.address }}
					</div>
				</div>
			</div>
			<div class="flex items-center justify-center flex-col">
				<div class="font-semibold text-2xl">
					{{ data.title }}
				</div>
				<div class="text-sm italic text-neutral-500">
					Ngày {{ date.date }} tháng {{ date.month + 1 }} năm
					{{ date.year }}
				</div>
			</div>
			<div class="flex items-start">
				<div class="mt-8 w-1/2">
					<div class="text-sm text-neutral-700">
						Học sinh: {{ data?.name }}
					</div>
					<div class="text-sm text-neutral-700 mt-4">
						Lớp bán trú: {{ data.day_care_class?.name }}
					</div>
					<div class="text-sm text-neutral-700 mt-4 flex gap-1">
						<div>Lớp nhóm:</div>
						<div>
							<div
								v-for="gClass in data?.group_classes"
								:key="gClass.id"
							>
								{{ gClass.name }}
							</div>
						</div>
					</div>
				</div>
				<div class="mt-8 w-1/2">
					<div class="text-sm font-semibold text-neutral-700">
						Thống kê chuyên cần
					</div>
					<div class="flex items-center flex-wrap mt-4 gap-4">
						<div
							class="text-sm text-neutral-700 w-statistic"
							v-for="i in data?.statistics"
							:key="i"
						>
							{{ i.name }}: {{ i.count }}
						</div>
					</div>
				</div>
			</div>

			<div class="mt-4">
				<div v-for="(form, i) in data?.forms" :key="i">
					<div class="w-fit min-w-full">
						<table class="min-w-full text-neutral-200">
							<thead class="h-12">
								<tr>
									<th
										class="
											px-3
											py-3
											text-center text-xs
											font-semibold
											text-neutral-600
											uppercase
											tracking-wider
											w-16
											whitespace-nowrap
											border
										"
										scope="col"
									>
										STT
									</th>
									<th
										class="
											px-3
											py-3
											text-left text-xs
											font-semibold
											text-neutral-600
											uppercase
											tracking-wider
											whitespace-nowrap
											border
										"
										scope="col"
									>
										{{ i === 0 ? 'Khoản Thu' : 'Hoàn Phí' }}
									</th>
									<th
										class="
											px-3
											py-3
											text-left text-xs
											font-semibold
											text-neutral-600
											uppercase
											tracking-wider
											whitespace-nowrap
											border
										"
										scope="col"
									>
										Chi phí (VNĐ)
									</th>
									<th
										class="
											px-3
											py-3
											text-left text-xs
											font-semibold
											text-neutral-600
											uppercase
											tracking-wider
											whitespace-nowrap
											border
										"
										scope="col"
										v-if="data?.show_discount"
									>
										Chi phí sau giảm giá (VNĐ)
									</th>
									<th
										class="
											px-3
											py-3
											text-left text-xs
											font-semibold
											text-neutral-600
											uppercase
											tracking-wider
											whitespace-nowrap
											border
										"
										scope="col"
									>
										Số lượng
									</th>
									<th
										class="
											px-3
											py-3
											text-left text-xs
											font-semibold
											text-neutral-600
											uppercase
											tracking-wider
											whitespace-nowrap
											border
										"
										scope="col"
									>
										Thành tiền (VNĐ)
									</th>
								</tr>
							</thead>
							<tbody>
								<tr
									v-for="(item, index) in form"
									:key="item.id"
									class="text-neutral-700"
								>
									<!-- <div v-if="item.price > 0"> -->
									<td class="border">
										<div
											class="
												px-3
												py-4
												text-center text-neutral-700
											"
										>
											{{ index + 1 }}
										</div>
									</td>
									<td
										class="
											px-3
											py-4
											text-neutral-700
											cursor-pointer
											border
										"
										style="max-width: 200px"
									>
										<div>
											{{ item?.name }}
										</div>
									</td>
									<td
										class="
											px-3
											py-4
											whitespace-nowrap
											text-neutral-700
											border
										"
									>
										<div>
											{{
												data?.show_discount
													? $filters.priceFormat(
															item.original_price
													  )
													: $filters.priceFormat(
															item.price
													  )
											}}
										</div>
									</td>
									<td
										class="
											px-3
											py-4
											whitespace-nowrap
											text-neutral-700
											border
										"
										v-if="data?.show_discount"
									>
										<div
											v-if="
												item.original_price ===
												item.price
											"
										>
											-
										</div>
										<div v-else>
											{{
												$filters.priceFormat(item.price)
											}}
										</div>
									</td>
									<td
										class="
											px-3
											py-4
											whitespace-nowrap
											text-neutral-700
											border
										"
									>
										{{ $filters.priceFormat(item.count) }}
									</td>
									<td
										class="
											px-3
											py-4
											whitespace-nowrap
											text-neutral-700
											border
										"
									>
										{{ $filters.priceFormat(item.total) }}
									</td>
									<!-- </div> -->
								</tr>
							</tbody>
						</table>
						<div
							class="
								capitalize
								h-12
								flex
								items-center
								justify-between
								bg-neutral-100
								border-l border-r
								px-4
								font-semibold
								text-neutral-500
							"
						>
							<div>
								Tổng {{ i === 0 ? ' Khoản Thu' : 'Hoàn Phí' }}
							</div>
							<div>
								{{ i === 0 ? '' : '-' }}
								{{
									$filters.priceFormat(
										i === 0
											? data.totalFee
											: data.totalRefund
									)
								}}
								VNĐ
							</div>
						</div>
					</div>
				</div>
			</div>
			<div
				class="
					capitalize
					h-12
					flex
					items-center
					justify-between
					border
					px-4
					font-semibold
					text-lg text-neutral-500
				"
			>
				<div>Tổng chi phí phụ huynh phải đóng</div>
				<div>
					{{ $filters.priceFormat(data.totalFee - data.totalRefund) }}
					VNĐ
				</div>
			</div>
			<div
				class="
					flex
					justify-between
					border
					p-4
					font-normal
					text-neutral-700 text-base
				"
				v-if="
					data?.other_components_and_settings?.settings
						?.enabled_common_note ||
					data?.other_components_and_settings?.settings
						?.enabled_qr_code
				"
			>
				<div
					v-if="
						data?.other_components_and_settings?.settings
							?.enabled_common_note && data.common_note
					"
					v-html="data.common_note.replace(/\n/g, '<br />')"
				></div>
				<img
					v-if="
						data?.other_components_and_settings?.settings
							?.enabled_qr_code && data.asset_url
					"
					style="width: 100px; height: 100px"
					:src="data.asset_url"
					alt=""
				/>
			</div>
			<div class="text-neutral-700 text-base mt-4" v-if="data.note">
				<span class="font-semibold">Ghi chú: </span>{{ data.note }}
			</div>
			<div class="flex items-end justify-center flex-col gap-2 mt-4 mr-4">
				<div class="text-neutral-500 text-sm">Người gửi thông báo</div>
				<div class="text-neutral-700 text-base font-semibold">
					{{ senderName }}
				</div>
			</div>
		</div>

		<div class="mt-10 flex items-center justify-center md:justify-end">
			<button
				class="button-p text-center w-fit px-10"
				type="button"
				@click="confirmSendOpen"
			>
				Gửi thông báo
			</button>
		</div>
	</div>
</template>

<script>
import { $api } from '@/services';
import { ACTIONS } from '@/enums/Common';
import DaModalFrame from '@/components/common/daModalFrame/DaModalFrame';
import ConfirmSendFeeNotice from '@/views/feeNoticesCreate/ConfirmSendFeeNotice';
// import ConfirmResend from '@/views/feeNotoceDetail/features/ConfirmResend';
// import { timeSince } from '@/helper/formatDate';
import dayjs from 'dayjs';

export default {
	name: 'FeeNoticeDetail',
	components: {
		ConfirmSendFeeNotice,
		DaModalFrame,
	},
	data() {
		return {
			modalIsOpen: false,
			notificationConfirm: null,
			inProgress: false,
			data: {
				name: '',
				title: '',
				day_care_class: {},
				group_classes: [],
				forms: [],
			},
			idFeeNotice: null,
			date: {
				date: new Date().getDate(),
				month: new Date().getMonth(),
				year: new Date().getFullYear(),
			},
		};
	},

	computed: {
		dayjs() {
			return dayjs;
		},
		id() {
			return this.$route.params.id || '';
		},

		type() {
			return ACTIONS;
		},

		isAdmin() {
			return this.$store.getters.isAdmin;
		},

		currentOrg() {
			return this.$store.state.profile.current_org;
		},
		senderName() {
			return this.$store.state.profile.staff.name;
		},
		templateId() {
			return this.$route.query.templateId;
		},
		tuitionId() {
			return this.$route.query.tuitionId;
		},
	},

	mounted() {
		const formPreview = window.sessionStorage.getItem('formPreview');
		if (formPreview) {
			this.data = JSON.parse(formPreview);
		} else {
			this.$router.push('/fee-notices');
		}
	},

	methods: {
		async getFeeNotificationsId() {
			this.inProgress = true;
			try {
				const res = await $api.notification.getFeeNotificationsId();
				if (res) this.idFeeNotice = res.data.data;
			} catch (e) {
				this.$store.dispatch('setAlertMessage', {
					message:
						e?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			} finally {
				this.inProgress = false;
			}
		},
		async sendNotification() {
			this.inProgress = true;
			let fee = this.data.forms[0].filter((i) => i.type !== 'fee');
			let refund = this.data.forms[1].filter((i) => i.type !== 'refund');
			let otherFee = this.data.forms[0].filter((i) => i.type == 'fee');
			let otherReFund = this.data.forms[1].filter(
				(i) => i.type == 'refund'
			);
			try {
				if (this.tuitionId && this.templateId) {
					await $api.notification.editFeeNotification(
						this.templateId,
						this.tuitionId,
						{
							send: true,
							note: this.data.note,
							data: {
								other_components_and_settings:
									this.data?.other_components_and_settings,
								fee: {
									default: fee,
									other: otherFee,
									total: this.data.totalFee,
								},
								refund: {
									default: refund,
									other: otherReFund,
									total: this.data.totalRefund,
								},
								schedule_statistics: this.data?.statistics,
								total:
									this.data.totalFee - this.data.totalRefund,
							},
						}
					);
				} else {
					await $api.notification.sendFeeNotification({
						send: true,
						student_id: this.id,
						subject: 'all_parents_of_a_student',
						title: this.data.title_of_notice,
						month_start: this.data.month_start,
						content: this.data.content,
						student_tuition_from_template: {
							note: this.data.note,
							data: {
								other_components_and_settings:
									this.data?.other_components_and_settings,
								fee: {
									default: fee,
									other: otherFee,
									total: this.data.totalFee,
								},
								refund: {
									default: refund,
									other: otherReFund,
									total: this.data.totalRefund,
								},
								schedule_statistics: this.data?.statistics,
								total:
									this.data.totalFee - this.data.totalRefund,
							},
							title: this.data.title,
							tuition_template_id: this.data.tuition_id,
						},
					});
				}
				this.cancel();
				this.$store.dispatch('setAlertMessage', {
					message: 'Gửi thông báo thành công',
				});
				this.$router.push('/fee-notices');
			} catch (e) {
				this.$store.dispatch('setAlertMessage', {
					message:
						e?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			} finally {
				this.inProgress = false;
			}
		},

		confirmSendOpen() {
			this.modalIsOpen = true;
			this.notificationConfirm = {
				name: this.data.name,
				title: this.data.title,
				money: this.data.totalFee - this.data.totalRefund,
				sender: this.senderName,
			};
		},

		cancel() {
			this.modalIsOpen = false;
		},

		// getTotal(arr) {
		// 	let sum = 0;
		// 	for (let card of arr)
		// 		sum = sum + card.fields[0].value * card.fields[1].value;
		// 	return sum;
		// },
	},
};
</script>
<style lang="scss" scoped>
.title {
	font-weight: 600;
	box-shadow: none !important;

	&::placeholder {
		font-weight: normal;
	}
}
.red-text {
	color: #e37056;
}
.w-statistic {
	width: calc(50% - 8px);
}
</style>
